module.exports = __webpack_public_path__ + "fcec1b450037fa56b9177aee4441af12.svg";